<script setup>

import { scrollIntoView } from '@/composables/helpers/client-only/scroll'

const route = useRoute()

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: 'Title',
    },
    items: {
        type: Array,
        required: false,
        default: [],
    },
    single: {
        type: Boolean,
        required: false,
        default: true,
    },
    headlineTag: {
        type: String,
        required: false,
        default: 'h3'
    },
    headlineClass: {
        type: String,
        required: false,
        default: 'h5'
    }
});

const itemsList = ref(props.items || [])
const anchor = ref()

function isHashMatch(str) {
    return route.hash === `#${str}`;
}

const update = () => {
    itemsList.value.forEach(item => {
        item.expanded = item.anchorId ? isHashMatch(item.anchorId) : false;
    });
}

const findHash = () => {
    if (route.hash) {
        const hash = route.hash
        const el = document.querySelector(`a[id='${hash.replace('#', '')}']`);
        if (el) scrollIntoView(el);
    }
}

onMounted(() => {
    if (process.client) setTimeout(() => { update() }, 500);
    if (process.client) setTimeout(() => { findHash() }, 750);
    
});

</script>

<template>
    <MessAccordion>
        <template #head>
            <MessHtml v-if="title" :html="title" tag="h2" />
        </template>
        <template #items>
            <MessFragmentsAccordionItem v-for="(item, index) in itemsList" :index="index" :key="`accord-item-${index}`" v-model:expanded="item.expanded">
                <template #title>
                    <MessHtml v-if="item.headline" :html="item.headline" :tag="headlineTag" :class="headlineClass" />
                    <a v-if="item.anchorId" :id="item.anchorId"  :name="item.anchorId" ref="anchor" />
                    <span aria-hidden="true" class="toggle-icon flex-none">
                        <svg viewBox="0 0 37 37" class="w-[32px] h-[32px] md:w-[28px] md:h-[28px]" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="18.5" cy="18.5" r="17.5" stroke-width="1" class="stroke-white fill-transparent" />
                            <line x1="12.75" y1="18.5" x2="24.25" y2="18.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-white" />
                            <line x1="18.5" y1="12.75" x2="18.5" y2="24.25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-white toggle-vertical transition-opacity duration-300" />
                        </svg>
                    </span>
                </template>
                <template #body>
                    <slot name="item" v-bind="[item.copy, index, item.anchorId]" />
                </template>
            </MessFragmentsAccordionItem>
        </template>
    </MessAccordion>
</template>

<style lang="scss">
.mess-accordion {
    
    button > * {
        margin-top: -4px;
        border-bottom: 0.5px solid transparent;
    }

    .accordion-item {

        +.accordion-item {
            margin-top: 1.875rem;
            padding-top: 1.875rem;
            border-top: 1px solid black;
        }

        .toggle-icon {
            margin-left: auto;
            flex-shrink: 0;
        }

        &.opened .toggle-vertical {
            opacity: 0;
        }

        @media(hover: hover) and (pointer: fine) {
            &:hover {
                button > * {
                    text-decoration: none;
                }
            }
        }
    }
}
</style>
